import React, { useEffect } from 'react';
import { Shield, Lock, Eye, FileText } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import PageHero from '../components/PageHero';

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = 'Privacy Policy | Digi Loans Bazaar - Hyderabad';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Digi Loans Bazaar privacy policy. Learn how we collect, use, and protect your personal information during loan applications.');
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-32">
        <PageHero
          badge="Privacy & Data Protection"
          badgeIcon={Shield}
          title="Privacy"
          highlightWord="Policy"
          subtitle="Last updated: December 2026"
          breadcrumb="Privacy Policy"
        />
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto">

            <div className="prose prose-lg max-w-none">
              <div className="bg-blue-50 border-l-4 border-blue-600 rounded-r-xl p-6 mb-8">
                <p className="text-gray-800 m-0">
                  At <strong>Digi Loans Bazaar</strong>, we respect your privacy and are committed to protecting your personal information.
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4 flex items-center gap-3">
                <FileText className="w-6 h-6 text-blue-600" /> Information We Collect
              </h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-6">
                <li><strong>Personal Details:</strong> Name, email, phone number, address</li>
                <li><strong>Financial Information:</strong> Income, employment details, loan requirements</li>
                <li><strong>Identification:</strong> KYC documents for loan processing</li>
                <li><strong>Business Details:</strong> For business and hospital loan applications</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4 flex items-center gap-3">
                <Eye className="w-6 h-6 text-blue-600" /> How We Use Your Information
              </h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-6">
                <li>To process your loan enquiry and facilitate funding</li>
                <li>To communicate with you about loan options and updates</li>
                <li>To connect you with our partner banks and NBFCs</li>
                <li>To comply with legal and regulatory requirements</li>
                <li>To improve our services and customer experience</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4 flex items-center gap-3">
                <Lock className="w-6 h-6 text-blue-600" /> Data Security
              </h2>
              <p className="text-gray-700">
                We implement industry-standard security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. All data transmissions are encrypted using SSL/TLS protocols.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Information Sharing</h2>
              <p className="text-gray-700">
                We share your information only with our partner banks, NBFCs, and financial institutions for the purpose of processing your loan application. We do not sell or rent your personal data to third parties.
              </p>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Your Rights</h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-6">
                <li>Right to access your personal information</li>
                <li>Right to correct inaccurate data</li>
                <li>Right to request deletion of your data</li>
                <li>Right to withdraw consent at any time</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Contact Us</h2>
              <p className="text-gray-700">
                For privacy-related queries:<br />
                Email: <a href="mailto:prasad@digiloansbazaar.com" className="text-blue-600 hover:underline">prasad@digiloansbazaar.com</a><br />
                Phone: <a href="tel:+919703850009" className="text-blue-600 hover:underline">+91 9703850009</a>
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default PrivacyPolicy;
